import { fmtNum } from "@/lib/format";
import { CheckCircle2, AlertTriangle, Clock } from "lucide-react";

const ICON = {
  done: <CheckCircle2 className="w-4 h-4 text-emerald-600" />,
  running: <Clock className="w-4 h-4 text-amber-600 animate-pulse" />,
  error: <AlertTriangle className="w-4 h-4 text-rose-600" />,
};
const when = (iso) => { try { return new Date(iso).toLocaleString("en-IN", { timeZone: "Asia/Kolkata", day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" }); } catch { return iso; } };
const n = (r, v) => (r.status === "running" ? "—" : fmtNum(v || 0));

const RunDetail = ({ r }) => (
  <div className="text-[11px] text-neutral-600 space-y-1 mt-1">
    {(r.error_samples || []).map((e, i) => <div key={i} className="font-mono">Row {e.row_number}: {e.reason}</div>)}
    {r.unmatched_store_bills > 0 && (
      <div className="text-rose-700" data-testid={`missing-bills-unmatched-${r.id}`}>
        {fmtNum(r.unmatched_store_bills)} bills added without a store (no matching store code/name):{" "}
        {(r.unmatched_stores || []).slice(0, 8).map((u) => `${u.store_name} (${u.bills})`).join(", ")}
      </div>
    )}
    {r.error && <div className="text-rose-700">{r.error}</div>}
  </div>
);

export const MissingBillRuns = ({ runs }) => (
  <div className="chart-card p-5" data-accent="teal" data-testid="missing-bills-runs">
    <h3 className="font-display text-lg mb-3">Uploads</h3>
    {runs.length === 0 ? (
      <div className="text-sm text-neutral-500 py-8 text-center">No uploads yet.</div>
    ) : (
      <table className="w-full text-sm">
        <thead>
          <tr className="text-left text-[10px] uppercase tracking-[0.15em] text-neutral-500 border-b">
            <th className="py-2 pr-4">When (IST)</th><th className="py-2 pr-4">File</th><th className="py-2 pr-4">Status</th>
            <th className="py-2 pr-4 text-right">Bills added</th><th className="py-2 pr-4 text-right">Already present</th><th className="py-2 text-right">Errors</th>
          </tr>
        </thead>
        <tbody>
          {runs.map((r) => (
            <tr key={r.id} className="border-b border-neutral-100 align-top" data-testid={`missing-bills-run-${r.id}`}>
              <td className="py-2 pr-4 whitespace-nowrap">{when(r.started_at)}</td>
              <td className="py-2 pr-4 max-w-[260px]"><div className="truncate" title={r.filename}>{r.filename}</div><RunDetail r={r} /></td>
              <td className="py-2 pr-4"><span className="inline-flex items-center gap-1.5">{ICON[r.status]}{r.status}</span></td>
              <td className="py-2 pr-4 text-right font-medium text-emerald-700" data-testid={`missing-bills-added-${r.id}`}>{n(r, r.added)}</td>
              <td className="py-2 pr-4 text-right text-neutral-600">{n(r, r.skipped_existing)}</td>
              <td className="py-2 text-right">{r.errors > 0 ? <span className="text-rose-600">{fmtNum(r.errors)}</span> : n(r, 0)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    )}
  </div>
);
